$.widget("chopin.business_name_check", $.bijou.base, {
  _create() {
    const widget = this;

    widget.controlBlock = this.element.closest(".control-block");

    if (this.element.val().trim()) {
      widget._doBusinessNameCheck(widget, this.element.val().trim());
    }

    widget.element.on("blur", (e) => {
      widget._doBusinessNameCheck(widget, e.target.value.trim());
    });

    widget.element.on("keydown", (e) => {
      // remove warning on delete/backspace to not overlap with empty validation error
      if (e.keyCode === 8 || e.keyCode === 46) {
        widget._clearWarning(widget, e.target.value.trim());
      }
    });
  },

  _registeredChecks() {
    return {
      _titleExists: [
        "Please provide a business name that is not solely a title e.g. Mr/Mrs/Miss/Ms/Dr.",
        (value) => value.match(/^((Mrs?)|(Miss)|(Ms)|(Dr)|(Mx))\.?$/i),
      ],
      _startNonAlphanumeric: [
        "Please provide a business name that does not start with a special character e.g. @, !",
        (value) => value.match(/^[_\W]/),
      ],
      _onlyNumbers: [
        "Please provide a business name that does not consist of solely numeric characters.",
        (value) => value.match(/^[\d.,]+$/),
      ],
      _emailAddress: [
        "Please provide a business name that is not an email address.",
        // eslint-disable-next-line
        value => value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
      ],
    };
  },

  _clearWarning(widget) {
    if (widget.controlBlock.find("label.suggestion").length > 0) {
      widget.controlBlock.find("label.suggestion").remove();
    }
  },

  _doBusinessNameCheck(widget, value) {
    widget._clearWarning(widget);

    const [checkSuggestion] =
      Object.values(widget._registeredChecks()).find(([, checkFunction]) =>
        checkFunction(value),
      ) || [];
    if (checkSuggestion) {
      widget._displaySuggestion(widget, checkSuggestion);
    }
  },

  _displaySuggestion(widget, suggestion) {
    const warningLabel = $("<label>")
      .attr({
        class: "suggestion business-name",
        for: widget.element.attr("name"),
      })
      .text(suggestion);

    widget.controlBlock.append(warningLabel);
  },
});
